<template>
  <v-dialog v-model="showDialog" max-width="390">
      <v-card>
        <v-card-title class="v-card__title headline">{{ $t(this.$props.message) }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" @click="showDialog = false;">{{ $t(this.$props.cancel) }}</v-btn>
          <v-btn color="success darken-1" @click="confirmClick">{{ $t(this.$props.confirm) }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDatePicker,
    VMenu,
    VIcon,
    VTextarea,
    VDataTable,
    VAutocomplete,
    VCheckbox,
    VAlert,
    VDialog
  } from 'vuetify/lib'
  import fccapi from '../fccapi.js'

  export default {
    name: 'ConfirmDialog',
    data: () => ({
      showDialog: false,
      parameter: null
    }),
    props: {
      message: String,
      confirm: String,
      cancel: String,
      onConfirm: Function
    },
    components: {
      VCard,
      VTooltip,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VSelect,
      VIcon,
      VDatePicker,
      VMenu,
      VDataTable,
      VTextarea,
      VAutocomplete,
      VCheckbox,
      VAlert,
      VDialog
    },
    methods: {
      show: function(obj){
        this.showDialog = true;
        this.parameter = obj;
      },
      save: function(){
        if(this.model.id != undefined){
          console.log("save "+this.model.id)
          fccapi.post(`categories/${this.model.id}`, this.model).then(d => {
            this.$store.dispatch('loadBaseData').then(e => {
              console.log("Base data loaded")
              this.dialog = false;
            }).catch(() => {
              console.log("Couldn't load base data")
            })
          }).catch(e => {
            console.log(e)
          })
        }else{
          this.model.CompetitionId = this.$store.getters.competitionId
          fccapi.post(`categories`, this.model).then(d => {
            this.$store.dispatch('loadBaseData').then(e => {
              console.log("Base data loaded")
              this.dialog = false;
            }).catch(() => {
              console.log("Couldn't load base data")
            })
          }).catch(e => {
            console.log(e)
          })
        }
      },
      confirmClick: function(){
        this.showDialog = false;
        this.$props.onConfirm(this.parameter);
      }
    },
    mounted: function(){
      
    }
  }
</script>